/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { TAnalyticsFields, TCarouselItem } from "../../model/types";

export interface TContentHighlightedFieldParams {
  dwellTimeMs: number;
  item: TCarouselItem;
  listName: string;
  listPosition: number;
  /**
   * The tile's index within its carousel row. Omit on a one-dimensional row
   * list (My Hub's Saved/Deleted and manage-series lists), where the row index
   * is the `list_position` and there is no second axis to report.
   */
  tilePosition?: number;
}

export const buildContentHighlightedFields = (
  params: TContentHighlightedFieldParams
): Partial<TAnalyticsFields> => {
  const contentType =
    params.item.feedItemType !== undefined && params.item.feedItemType !== null
      ? params.item.feedItemType
      : String(params.item.contentType);

  return {
    list_name: params.listName,
    list_position: String(params.listPosition),
    tile_position:
      params.tilePosition !== undefined
        ? String(params.tilePosition)
        : undefined,
    content_id: params.item.id,
    content_title: params.item.title,
    dwell_time_ms: String(params.dwellTimeMs),
    content_type: contentType,
    channel_id: params.item.stationId,
    season_number:
      params.item.seasonNumber !== undefined
        ? String(params.item.seasonNumber)
        : undefined,
    episode_number:
      params.item.episodeNumber !== undefined
        ? String(params.item.episodeNumber)
        : undefined
  };
};
